export default __webpack_public_path__ + "static/media/view-app-arrow.e946c3c7.svg";